import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import type { AttendanceItem } from '../types'

interface RecentChatsProps {
  attendances: AttendanceItem[]
}

export function RecentChats({ attendances }: RecentChatsProps) {
  return (
    <div className='space-y-8'>
      {attendances.map((attendance, index) => (
        <div key={index} className='flex items-center gap-4'>
          <Avatar className='h-9 w-9'>
            <AvatarFallback>{attendance.initials}</AvatarFallback>
          </Avatar>
          <div className='flex flex-1 flex-wrap items-center justify-between'>
            <div className='space-y-1'>
              <p className='text-sm font-medium leading-none'>
                {attendance.name}
              </p>
              <p className='text-sm text-muted-foreground'>
                {attendance.department}
              </p>
            </div>
            <div className='font-medium'>{attendance.duration}</div>
          </div>
        </div>
      ))}
    </div>
  )
} 